/**
 * @generated SignedSource<<c0108b47fa8b5233f696bcbfd41bd01c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
export type CompetitionJoinButtonMutation$variables = {
  agree: boolean;
  competitionId: string;
  forumId: string;
  join: boolean;
  subscribe: boolean;
};
export type CompetitionJoinButtonMutation$data = {
  readonly agreeToCompetitionRule?: {
    readonly competitionRule: {
      readonly competition: {
        readonly entityRuleAgreements: {
          readonly nodes: ReadonlyArray<{
            readonly id: string;
          }>;
        };
        readonly id: string;
        readonly latestRule: {
          readonly entityAgreement: {
            readonly createdAt: DateTime;
            readonly id: string;
          } | null | undefined;
          readonly id: string;
        };
      };
    };
    readonly createdAt: DateTime;
    readonly id: string;
  };
  readonly joinCompetition?: {
    readonly node: {
      readonly competition: {
        readonly membership: {
          readonly id: string;
        } | null | undefined;
      };
      readonly id: string;
    };
  } | null | undefined;
  readonly subscribeToSubject?: {
    readonly node: {
      readonly subject: {
        readonly entitySubscription: {
          readonly id: string;
        } | null | undefined;
        readonly id: string;
      };
    };
  };
};
export type CompetitionJoinButtonMutation = {
  response: CompetitionJoinButtonMutation$data;
  variables: CompetitionJoinButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agree"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "competitionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forumId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "join"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subscribe"
},
v5 = [
  {
    "kind": "Variable",
    "name": "competitionId",
    "variableName": "competitionId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v6/*:: as any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "CompetitionMembership",
  "kind": "LinkedField",
  "name": "membership",
  "plural": false,
  "selections": (v7/*:: as any*/),
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "competition",
    "variableName": "competitionId"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Competition",
  "kind": "LinkedField",
  "name": "competition",
  "plural": false,
  "selections": [
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "CompetitionRuleAgreementConnection",
      "kind": "LinkedField",
      "name": "entityRuleAgreements",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionRuleAgreement",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v7/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": "entityRuleAgreements(first:1)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompetitionRule",
      "kind": "LinkedField",
      "name": "latestRule",
      "plural": false,
      "selections": [
        (v6/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionRuleAgreement",
          "kind": "LinkedField",
          "name": "entityAgreement",
          "plural": false,
          "selections": [
            (v6/*:: as any*/),
            (v10/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = [
  {
    "kind": "Variable",
    "name": "subject",
    "variableName": "forumId"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionJoinButtonMutation",
    "selections": [
      {
        "condition": "join",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "CompetitionMembershipEdge",
            "kind": "LinkedField",
            "name": "joinCompetition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionMembership",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Competition",
                    "kind": "LinkedField",
                    "name": "competition",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "agree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v9/*:: as any*/),
            "concreteType": "CompetitionRuleAgreement",
            "kind": "LinkedField",
            "name": "agreeToCompetitionRule",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionRule",
                "kind": "LinkedField",
                "name": "competitionRule",
                "plural": false,
                "selections": [
                  (v11/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "subscribe",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v12/*:: as any*/),
            "concreteType": "SubjectSubscriptionEdge",
            "kind": "LinkedField",
            "name": "subscribeToSubject",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "subject",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "entitySubscription",
                        "plural": false,
                        "selections": (v7/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v0/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionJoinButtonMutation",
    "selections": [
      {
        "condition": "join",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "CompetitionMembershipEdge",
            "kind": "LinkedField",
            "name": "joinCompetition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionMembership",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Competition",
                    "kind": "LinkedField",
                    "name": "competition",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/),
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "agree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v9/*:: as any*/),
            "concreteType": "CompetitionRuleAgreement",
            "kind": "LinkedField",
            "name": "agreeToCompetitionRule",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionRule",
                "kind": "LinkedField",
                "name": "competitionRule",
                "plural": false,
                "selections": [
                  (v11/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "subscribe",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v12/*:: as any*/),
            "concreteType": "SubjectSubscriptionEdge",
            "kind": "LinkedField",
            "name": "subscribeToSubject",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v13/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "subject",
                    "plural": false,
                    "selections": [
                      (v13/*:: as any*/),
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "entitySubscription",
                        "plural": false,
                        "selections": [
                          (v13/*:: as any*/),
                          (v6/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "408b572c913d234212003c1f94a0d361",
    "id": null,
    "metadata": {},
    "name": "CompetitionJoinButtonMutation",
    "operationKind": "mutation",
    "text": "mutation CompetitionJoinButtonMutation(\n  $competitionId: ID!\n  $forumId: ID!\n  $join: Boolean!\n  $agree: Boolean!\n  $subscribe: Boolean!\n) {\n  joinCompetition(competitionId: $competitionId) @include(if: $join) {\n    node {\n      id\n      competition {\n        membership {\n          id\n        }\n        id\n      }\n    }\n  }\n  agreeToCompetitionRule(competition: $competitionId) @include(if: $agree) {\n    id\n    createdAt\n    competitionRule {\n      competition {\n        id\n        entityRuleAgreements(first: 1) @ifAllowed {\n          nodes {\n            id\n          }\n        }\n        latestRule {\n          id\n          entityAgreement @ifAllowed {\n            id\n            createdAt\n          }\n        }\n      }\n      id\n    }\n  }\n  subscribeToSubject(subject: $forumId) @include(if: $subscribe) {\n    node {\n      __typename\n      subject {\n        __typename\n        id\n        entitySubscription @ifAllowed {\n          __typename\n          id\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9061be7f7b4ed0ae6dac4c18b212aaf3";

export default node;
